// Define minimum height of the document
export const defineDocumentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--doc.height", `${window.innerHeight}px`);
};

window.addEventListener("resize", defineDocumentHeight);
defineDocumentHeight();
